import { render, staticRenderFns } from "./upload-test.vue?vue&type=template&id=4d9eed27&scoped=true&"
import script from "./upload-test.vue?vue&type=script&lang=js&"
export * from "./upload-test.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d9eed27",
  null
  
)

export default component.exports